import React from 'react';
import { Link } from 'react-router-dom';
import styles from '../styles/Internship.module.css';
import WireframeBackground from '../components/WireframeBackground';

function Internship() {
    return (
        <div className={styles.container}>
            <WireframeBackground />
            <div className={styles.wrap}>
                <section className={styles.recruitSection}>
                    <div className={styles.header}>
                        <h1 className={styles.sectionTitle}>INTERNSHIP</h1>
                        <p className={styles.subtitle}>インターンシップ</p>
                    </div>

                    <div className={styles.heroCard}>
                        <div className={styles.cornerTL}></div>
                        <div className={styles.cornerTR}></div>
                        <div className={styles.cornerBL}></div>
                        <div className={styles.cornerBR}></div>
                        <h2 className={styles.heroTitle}>現場レベルのリグをParnasで学びませんか？</h2>
                        <p className={styles.heroText}>
                            全国どこからでも参加いただけます。既卒・翌年度卒業生も対象です！
                        </p>
                    </div>

                    <div className={styles.content}>
                        {/* 概要 */}
                        <div className={styles.infoCard}>
                            <div className={styles.cornerTL}></div>
                            <div className={styles.cornerTR}></div>
                            <div className={styles.cornerBL}></div>
                            <div className={styles.cornerBR}></div>
                            <h3 className={styles.title}>概要</h3>
                            <table className={styles.recruitTable}>
                                <tbody>
                                    <tr>
                                        <th>期間</th>
                                        <td>2026年7月27日(月)～8月7日(金)（実働10日間）</td>
                                    </tr>
                                    <tr>
                                        <th>対象年次</th>
                                        <td>2027年3月末卒、および2028年3月卒、既卒</td>
                                    </tr>
                                    <tr>
                                        <th>募集〆切</th>
                                        <td>2026年6月末</td>
                                    </tr>
                                    <tr>
                                        <th>応募方法</th>
                                        <td>ポートフォリオを添付の上、問い合わせ（採用応募）よりエントリーください。</td>
                                    </tr>
                                    <tr>
                                        <th>選考フロー</th>
                                        <td>書類選考 → 面接（原則オンライン）</td>
                                    </tr>
                                    <tr>
                                        <th>報酬</th>
                                        <td>有償（5万円）</td>
                                    </tr>
                                    <tr>
                                        <th>内定について</th>
                                        <td>優秀な成績を収めた方には、本採用選考における優遇措置（または内定）をご提案させていただきます。</td>
                                    </tr>
                                    <tr>
                                        <th>勤務地</th>
                                        <td>在宅</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        {/* インターン内容 */}
                        <div className={styles.infoCard}>
                            <div className={styles.cornerTL}></div>
                            <div className={styles.cornerTR}></div>
                            <div className={styles.cornerBL}></div>
                            <div className={styles.cornerBR}></div>
                            <h3 className={styles.title}>インターン内容</h3>
                            <div className={styles.internContent}>
                                <p>プロのリガーによる実践的な指導のもと、Maya（mgear）を使用したBodyリグ制作を体験できます</p>
                                <ul style={{ marginTop: '20px', listStyleType: 'square', paddingLeft: '20px' }}>
                                    <li>Bodyリグ（骨配置、ウエイト調整、コントローラー作成）</li>
                                </ul>
                                <p style={{ marginTop: '20px', fontSize: '0.9rem', opacity: 0.8 }}>
                                    ※応募者の習熟度を踏まえて内容を変更させていただく場合がございます。
                                </p>
                            </div>
                        </div>

                        {/* 実績 */}
                        <div className={styles.infoCard}>
                            <div className={styles.cornerTL}></div>
                            <div className={styles.cornerTR}></div>
                            <div className={styles.cornerBL}></div>
                            <div className={styles.cornerBR}></div>
                            <h3 className={styles.title}>2025年インターン実績</h3>
                            <div className={styles.achievementBox}>
                                <div>
                                    <p>応募15名、インターン実施3名</p>
                                    <p>インターン期間：1週間</p>
                                </div>
                                <div className={styles.achievementItem}>
                                    <p className={styles.achievementTitle}>インターン参加者の感想</p>
                                    <ul className={styles.impressionList}>
                                        <li>「学校では学べないレベルの内容が詰め込まれていました」</li>
                                        <li>「フィードバックが多かったものの先輩が丁寧に教えていただき勉強になりました」</li>
                                    </ul>
                                </div>
                            </div>
                        </div>

                        {/* 注意事項 */}
                        <div className={styles.infoCard}>
                            <div className={styles.cornerTL}></div>
                            <div className={styles.cornerTR}></div>
                            <div className={styles.cornerBL}></div>
                            <div className={styles.cornerBR}></div>
                            <h3 className={styles.title}>注意事項</h3>
                            <p className={styles.noteText}>
                                当社のインターンは、キャリア形成支援として実施致します。参加については、各学校の方針をご確認の上ご参加ください。
                            </p>
                        </div>

                        <div className={styles.buttonWrapper}>
                            <Link to="/contact" className={styles.contactButton}>エントリー（問い合わせ）へ</Link>
                        </div>
                    </div>
                </section>
            </div>
        </div>
    );
}

export default Internship;
